<template>
    <sa-page-layout :btnBackVisible="true" :btnRefreshVisible="true" :linkback="linkback" :pathResource="pathResource" :showModalLoading="showModalLoading" @refresh="onRefresh">
        <template slot="toolbar-title">
            <rsa-ospite-anagrafica-component :jsonData="jsonData"></rsa-ospite-anagrafica-component>
        </template>

        <template slot="table-body">
            <rsa-paziente-scheda-programma-riabilitativo-list-component
                ref="cmpRsaPazienteSchedaProgrammaRiabilitativoList"
                @beforeLoadData="onBeforeLoadData"
                @afterLoadData="onAfterLoadData"
            ></rsa-paziente-scheda-programma-riabilitativo-list-component>
        </template>
    </sa-page-layout>
</template>

<script>
import axios from "axios";
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaOspiteAnagraficaComponent from "../../rsagestioneospiti/components/RsaOspiteAnagraficaComponent.vue";
import RsaPazienteSchedaProgrammaRiabilitativoListComponent from "../components/RsaPazienteSchedaProgrammaRiabilitativoListComponent.vue";

export default {
    name: "RsaPazienteSchedaProgrammaRiabilitativoListPage",
    components: {
        SaPageLayout,
        RsaOspiteAnagraficaComponent,
        RsaPazienteSchedaProgrammaRiabilitativoListComponent,
    },
    data() {
        return {
            idAccettazione: null,
            pathResource: "/rsaschedaprogrammariabilitativo",
            pathResourceAccettazione: "/accettazioni",
            linkback: "/rsagestioneospiti",
            showModalLoading: false,
            jsonData: {
                accettazioneAnagrafica: {},
                accettazionePrestazioni: {},
                accettazioneStati: [],
                accettazioneStruttura: {},
                accettazionePresidio: {},
            },
        };
    },
    mounted() {
        let me = this;
        me.idAccettazione = me.$route.query.idAccettazione;
        me.loadAccettazione();
    },
    methods: {

        loadAccettazione() {
            let me = this;
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceAccettazione + "/" + me.idAccettazione;
            axios
                .get(link)
                .then(me.loadAccettazioneSuccess)
                .catch(me.loadAccettazioneError);
        },
        loadAccettazioneSuccess(response) {
            let me = this;
            me.jsonData = response.data.data;
            me.$refs.cmpRsaPazienteSchedaProgrammaRiabilitativoList.init(me.idAccettazione);
        },
        loadAccettazioneError(error) {
            let me = this;
            console.log(error);
            me.showModalLoading = false;
            me.$bvToast.toast("Errore nel caricamento dei dati del paziente", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onRefresh() {
            let me = this;
            me.loadAccettazione();
        },
    },
};
</script>

